module.exports = __webpack_public_path__ + "static/img/igo-mifi_mobile.e76223f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/igo-mifi_mobile.png
// module id = 643
// module chunks = 0